import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { HistoryAndCommentLoader } from "../../component/LoadersTemplate";
import LoaderTemplate from "../../component/LoaderTemplate";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import IssueActivityHistory from "../issueDetail/IssueActivityHistory";
import NoComments from "../../assets/no_comments.png";
import AiButton from "./AiButton";
import { useLocation } from "react-router-dom";
import { AISummaryModal } from "./AISummaryModal";
export default ({
  isLoading,
  data,
  template,
  isUserPMG,
  issueData,
  getAllComments
}) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  getAllComments(data);
  const issueId = query.get("issueId");
  const projectId = query.get("projectId");
  const [isOpen, setIsOpen] = useState(false);
  //console.log(data);
  const handleClick = value => {
    setIsOpen(value); // true / false
  };
  const aiLinks = {
    2405: "https://pmg.akosh.in/pmg_web_new/home/issues/2405/projects/1157/view-details",
    14916: "https://pmg.akosh.in/pmg_web_new/home/issues/14916/projects/1195/view-details",
    15344: "https://pmg.akosh.in/pmg_web_new/home/issues/15344/projects/1195/view-details",
    15493: "https://pmg.akosh.in/pmg_web_new/home/issues/15493/projects/1195/view-details",
    15295: "https://pmg.akosh.in/pmg_web_new/home/issues/15295/projects/1199/view-details",
    15501: "https://pmg.akosh.in/pmg_web_new/home/issues/15501/projects/1195/view-details",
    15494: "https://pmg.akosh.in/pmg_web_new/home/issues/15494/projects/1195/view-details",
    13689: "https://pmg.akosh.in/pmg_web_new/home/issues/15494/projects/1195/view-details",
    12424: "https://pmg.akosh.in/pmg_web_new/home/issues/12424/projects/2388/view-details",
    15749: "https://pmg.akosh.in/pmg_web_new/home/issues/15749/projects/2388/view-details",
    15193: "https://pmg.akosh.in/pmg_web_new/home/issues/15193/projects/650/view-details",
    15066: "https://pmg.akosh.in/pmg_web_new/home/issues/15066/projects/650/view-details",
    15301: "https://pmg.akosh.in/pmg_web_new/home/issues/15301/projects/3148/view-details",
    15299: "https://pmg.akosh.in/pmg_web_new/home/issues/15299/projects/3148/view-details",
    15300: "https://pmg.akosh.in/pmg_web_new/home/issues/15300/projects/3148/view-details",
    15413: "https://pmg.akosh.in/pmg_web_new/home/issues/15413/projects/4689/view-details",
    13399: "https://pmg.akosh.in/pmg_web_new/home/issues/13399/projects/4689/view-details",
    15415: "https://pmg.akosh.in/pmg_web_new/home/issues/15415/projects/4689/view-details",
    14445: "https://pmg.akosh.in/pmg_web_new/home/issues/14445/projects/4689/view-details",
    6667: "https://pmg.akosh.in/pmg_web_new/home/issues/6667/projects/1616/view-details",
    15602: "https://pmg.akosh.in/pmg_web_new/home/issues/15602/projects/4398/view-details",
    15847: "https://pmg.akosh.in/pmg_web_new/home/issues/15847/projects/9966/view-details",
    16128: "https://pmg.akosh.in/pmg_web_new/home/issues/16128/projects/10716/view-details",
    16136: "https://pmg.akosh.in/pmg_web_new/home/issues/16136/projects/10716/view-details",
    16133: "https://pmg.akosh.in/pmg_web_new/home/issues/16133/projects/10716/view-details",
    16132: "https://pmg.akosh.in/pmg_web_new/home/issues/16132/projects/10716/view-details",
    16134: "https://pmg.akosh.in/pmg_web_new/home/issues/16134/projects/10716/view-details",
    16078: "https://pmg.akosh.in/pmg_web_new/home/issues/16078/projects/9889/view-details",
    15731: "https://pmg.akosh.in/pmg_web_new/home/issues/15731/projects/9889/view-details",
    16077: "https://pmg.akosh.in/pmg_web_new/home/issues/16077/projects/9889/view-details",
    15727: "https://pmg.akosh.in/pmg_web_new/home/issues/15727/projects/9889/view-details",
    16050: "https://pmg.akosh.in/pmg_web_new/home/issues/16050/projects/7657/view-details",
    15849: "https://pmg.akosh.in/pmg_web_new/home/issues/15849/projects/7657/view-details",
    15468: "https://pmg.akosh.in/pmg_web_new/home/issues/15468/projects/7657/view-details",
    16073: "https://pmg.akosh.in/pmg_web_new/home/issues/16073/projects/7529/view-details",
    15271: "https://pmg.akosh.in/pmg_web_new/home/issues/15271/projects/7449/view-details",
    16072: "https://pmg.akosh.in/pmg_web_new/home/issues/16072/projects/7529/view-details",
    15881: "https://pmg.akosh.in/pmg_web_new/home/issues/15881/projects/7086/view-details",
    15570: "https://pmg.akosh.in/pmg_web_new/home/issues/15570/projects/7086/view-details",
    15565: "https://pmg.akosh.in/pmg_web_new/home/issues/15565/projects/7086/view-details",
    15880: "https://pmg.akosh.in/pmg_web_new/home/issues/15880/projects/7086/view-details",
    16102: "https://pmg.akosh.in/pmg_web_new/home/issues/16102/projects/7085/view-details",
    16100: "https://pmg.akosh.in/pmg_web_new/home/issues/16100/projects/7085/view-details",
    16097: "https://pmg.akosh.in/pmg_web_new/home/issues/16097/projects/7085/view-details",
    15737: "https://pmg.akosh.in/pmg_web_new/home/issues/15737/projects/7085/view-details",
    15899: "https://pmg.akosh.in/pmg_web_new/home/issues/15899/projects/7081/view-details",
    15560: "https://pmg.akosh.in/pmg_web_new/home/issues/15560/projects/7081/view-details",
    14931: "https://pmg.akosh.in/pmg_web_new/home/issues/14931/projects/7077/view-details",
    14934: "https://pmg.akosh.in/pmg_web_new/home/issues/14934/projects/7077/view-details",
    14933: "https://pmg.akosh.in/pmg_web_new/home/issues/14933/projects/7077/view-details",
    14948: "https://pmg.akosh.in/pmg_web_new/home/issues/14948/projects/7077/view-details",
    14932: "https://pmg.akosh.in/pmg_web_new/home/issues/14932/projects/7077/view-details",
    15445: "https://pmg.akosh.in/pmg_web_new/home/issues/15445/projects/7062/view-details",
    14851: "https://pmg.akosh.in/pmg_web_new/home/issues/14851/projects/7062/view-details",
    15266: "https://pmg.akosh.in/pmg_web_new/home/issues/15266/projects/5751/view-details",
    15234: "https://pmg.akosh.in/pmg_web_new/home/issues/15234/projects/5751/view-details",
    15959: "https://pmg.akosh.in/pmg_web_new/home/issues/15959/projects/5689/view-details"
  };

  const aiLink = aiLinks[issueId];

  const dataToIterate = data
    ? isValidArray(data.filter(value => isValidArray(value)))
    : [];

  const commentList = [];
  let commentExists = false;
  if (isValidArray(dataToIterate)) {
    dataToIterate.forEach(data => {
      data.forEach(comment => {
        if (!comment.isAutomated) {
          commentList.push(comment);
        }
        if (comment.isAutomated && !comment.isChildIssueComment) {
          commentList.push(comment);
        }
        if (
          comment.isAutomated &&
          comment.isChildIssueComment &&
          comment.isChildResolved
        ) {
          commentList.push(comment);
        }
      });
    });
    //console.log("commentList", commentList);
    commentList.sort(function(x, y) {
      return y.date - x.date;
    });
    commentExists = true;
  }
  return (
    <div className="history-activity-content">
      {isLoading === STATUS.LOADING ? (
        <LoaderTemplate
          height={80}
          width={300}
          children={<HistoryAndCommentLoader />}
        />
      ) : (
        <>
          {isOpen ? (
            <AISummaryModal
              isOpen={isOpen}
              onClick={handleClick}
              issueData={issueData}
            />
          ) : null}
          {/* {aiLink && <AiButton height={32} label="AI Zone" url={aiLink} />} */}
          {isUserPMG ? (
            <AiButton height={32} label="AI Insights" onClick={handleClick} />
          ) : null}
          {commentExists ? (
            <div className="update-issue-comments-section">
              {commentList.map((comment, index) => (
                <div key={comment.date}>
                  <IssueActivityHistory
                    history={comment}
                    type="comment"
                    pendingComments={comment.status == "PENDING"}
                    approvedBy={comment.approvedBy}
                    modifiedBy={comment.modifiedDate}
                    getAllComments={getAllComments}
                    buttonVisibility={true}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data">
              <Image
                src={NoComments}
                alt="No comments"
                className="no-comments-image"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
